import { coreApi } from 'src/api/config';

const populatePreferredLanguages = async (contact) => {
  const recordLanguagesResponse = await coreApi.query(
    'record_languages',
    { record_id: contact.id, record_type: 'Person' },
  );

  return {
    ...contact,
    preferred_languages: recordLanguagesResponse?.data.data || [],
  };
};

export default populatePreferredLanguages;
